module.exports = __webpack_public_path__ + "static/img/checkImgDetails.5e718ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/checkImgDetails.png
// module id = ntLn
// module chunks = 3